(() => {
  if (window.__vaultOldHeaderBoundV3) return;
  window.__vaultOldHeaderBoundV3 = true;
  document.documentElement.classList.remove('no-js');

  const desktopMedia = window.matchMedia('(min-width: 990px)');
  const scrollRoot = document.querySelector('.page-wrapper') || window;
  const getScrollY = () => Math.max(window.scrollY || 0, scrollRoot === window ? 0 : (scrollRoot.scrollTop || 0));

  const ensureOpeningCoverFixes = () => {
    document.querySelectorAll('[data-vault-magazine]').forEach((cover) => {
      cover.querySelector('.vault-magazine-reveal__eyebrow')?.classList.add('vault-eyebrow');
    });

    if (document.getElementById('vault-opening-cover-fixes')) return;
    const style = document.createElement('style');
    style.id = 'vault-opening-cover-fixes';
    style.textContent = `
      .vault-magazine-cover .vault-magazine-reveal__eyebrow{margin:0 0 12px!important;}
      .vault-magazine-cover .vault-magazine-reveal__header{padding-top:clamp(78px,7vw,108px)!important;}
      .vault-magazine-cover .vault-magazine-reveal__close{
        position:relative!important;z-index:12!important;display:inline-flex!important;
        align-items:center!important;justify-content:center!important;min-width:44px!important;
        min-height:38px!important;padding:8px 0 7px!important;pointer-events:auto!important;
        touch-action:manipulation!important;
      }
      html body.template-index:has(.vault-magazine-cover.is-open) .site-header:not(.is-scrolled) a.vault-wordmark--header-text,
      html body.template-index:has(.vault-magazine-cover.is-open) .site-header:not(.is-scrolled) a.vault-wordmark--header-text .vault-wordmark__text,
      html body:has(#MainContent[data-template="index"] .vault-magazine-cover.is-open) .site-header:not(.is-scrolled) a.vault-wordmark--header-text,
      html body:has(#MainContent[data-template="index"] .vault-magazine-cover.is-open) .site-header:not(.is-scrolled) a.vault-wordmark--header-text .vault-wordmark__text{
        color:#0F100E!important;-webkit-text-fill-color:#0F100E!important;
      }
      @media(max-width:749px){
        .vault-magazine-cover .vault-magazine-reveal__header{padding-top:18px!important;}
        .vault-magazine-cover .vault-magazine-reveal__close{min-height:40px!important;}
      }
    `;
    document.head.appendChild(style);
  };

  const closeOpeningCover = (closeButton) => {
    const cover = closeButton?.closest('[data-vault-magazine]');
    if (!cover || !cover.classList.contains('is-open')) return;
    const openButton = cover.querySelector('[data-vault-magazine-open]');
    const panel = cover.querySelector('[data-vault-magazine-panel]');
    const front = cover.querySelector('[data-vault-magazine-front]');
    cover.classList.remove('is-open');
    cover.classList.add('is-closed');
    openButton?.setAttribute('aria-expanded', 'false');
    panel?.setAttribute('aria-hidden', 'true');
    front?.setAttribute('aria-hidden', 'false');
    panel?.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])').forEach((element) => element.setAttribute('tabindex', '-1'));
    window.setTimeout(() => openButton?.focus({ preventScroll: true }), 0);
  };

  const closeDesktopMenus = (except) => {
    document.querySelectorAll('[data-header-menu][open]').forEach((menu) => {
      if (menu !== except) menu.removeAttribute('open');
    });
  };

  const clearBrandState = (wrapper) => {
    wrapper.classList.remove('is-nav-open', 'is-mega-open');
    wrapper.querySelectorAll('.vault-serge-mega__item.is-active').forEach((item) => item.classList.remove('is-active'));
  };

  const closeBrandMegas = (except) => {
    document.querySelectorAll('.vault-header-brand-hover').forEach((wrapper) => {
      if (wrapper !== except) clearBrandState(wrapper);
    });
  };

  const syncOpenState = () => {
    const mobile = Boolean(document.querySelector('[data-mobile-menu][open]'));
    const desktop = Boolean(document.querySelector('[data-header-menu][open]'));
    const brand = Boolean(document.querySelector('.vault-header-brand-hover.is-mega-open'));
    document.body.classList.toggle('mobile-menu-open', mobile);
    document.body.classList.toggle('header-menu-open', desktop || brand);
  };

  const closeAllHeaderMenus = () => {
    closeDesktopMenus();
    closeBrandMegas();
    document.querySelectorAll('[data-mobile-menu][open]').forEach((menu) => menu.removeAttribute('open'));
    syncOpenState();
  };

  const bindBrandMega = (wrapper) => {
    if (wrapper.dataset.vaultBrandMegaBoundV3 === 'true') return;
    wrapper.dataset.vaultBrandMegaBoundV3 = 'true';

    const menu = wrapper.querySelector('.vault-header-brand-hover__menu');
    const brand = wrapper.querySelector('.vault-wordmark--header-text');
    if (!menu || !brand) return;

    const categoryItems = [...menu.querySelectorAll('.vault-serge-mega__item:not(.vault-serge-mega__item--shop-all)')];
    let closeTimer = null;

    const cancelClose = () => {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = null;
    };

    const setActiveCategory = (item = categoryItems[0]) => {
      categoryItems.forEach((category) => category.classList.toggle('is-active', category === item));
    };

    const openMega = (item = categoryItems[0]) => {
      if (!desktopMedia.matches || !categoryItems.length) return;
      cancelClose();
      closeDesktopMenus();
      closeBrandMegas(wrapper);
      setActiveCategory(item || categoryItems[0]);
      wrapper.classList.remove('is-nav-open');
      wrapper.classList.add('is-mega-open');
      syncOpenState();
    };

    const scheduleClose = (event, delay = 280) => {
      if (!desktopMedia.matches) return;
      const next = event && event.relatedTarget;
      if (next && wrapper.contains(next)) return;
      cancelClose();
      closeTimer = setTimeout(() => {
        if (wrapper.matches(':hover') || wrapper.contains(document.activeElement)) return;
        clearBrandState(wrapper);
        syncOpenState();
      }, delay);
    };

    brand.addEventListener('pointerenter', () => openMega(categoryItems[0]));
    brand.addEventListener('focusin', () => openMega(categoryItems[0]));

    wrapper.addEventListener('pointerenter', () => {
      cancelClose();
      if (!wrapper.classList.contains('is-mega-open')) openMega(categoryItems[0]);
    });
    wrapper.addEventListener('pointerleave', (event) => scheduleClose(event, 300));

    menu.addEventListener('pointerenter', () => {
      cancelClose();
      if (!wrapper.classList.contains('is-mega-open')) openMega(categoryItems[0]);
    });
    menu.addEventListener('pointerleave', (event) => scheduleClose(event, 300));

    categoryItems.forEach((item) => {
      item.addEventListener('pointerenter', () => openMega(item));
      item.addEventListener('focusin', () => openMega(item));
    });

    wrapper.addEventListener('focusout', (event) => {
      if (!wrapper.contains(event.relatedTarget)) scheduleClose(event, 120);
    });
  };

  const bindDesktopMenu = (menu) => {
    if (menu.dataset.vaultOldBoundV3 === 'true') return;
    menu.dataset.vaultOldBoundV3 = 'true';
    let timer;
    const open = () => {
      if (!desktopMedia.matches) return;
      clearTimeout(timer);
      closeBrandMegas();
      closeDesktopMenus(menu);
      menu.setAttribute('open', '');
      syncOpenState();
    };
    const close = () => {
      if (!desktopMedia.matches) return;
      timer = setTimeout(() => {
        menu.removeAttribute('open');
        syncOpenState();
      }, 140);
    };
    menu.addEventListener('mouseenter', open);
    menu.addEventListener('mouseleave', close);
    menu.addEventListener('focusin', open);
    menu.addEventListener('focusout', (event) => {
      if (!menu.contains(event.relatedTarget)) close();
    });
    menu.addEventListener('toggle', syncOpenState);
  };

  const bindMobileMenu = (menu) => {
    if (menu.dataset.vaultOldBoundV3 === 'true') return;
    menu.dataset.vaultOldBoundV3 = 'true';
    menu.addEventListener('toggle', () => {
      syncOpenState();
      if (menu.open) menu.querySelector('[data-mobile-menu-close]')?.focus({ preventScroll: true });
    });
    menu.querySelector('[data-mobile-menu-close]')?.addEventListener('click', () => {
      menu.removeAttribute('open');
      menu.querySelector(':scope > summary')?.focus();
      syncOpenState();
    });
  };

  const bindLocalization = (select) => {
    if (select.dataset.vaultOldBoundV3 === 'true') return;
    select.dataset.vaultOldBoundV3 = 'true';
    select.addEventListener('change', () => {
      if (typeof select.form?.requestSubmit === 'function') select.form.requestSubmit();
      else select.form?.submit();
    });
  };

  const initialize = (root = document) => {
    ensureOpeningCoverFixes();
    root.querySelectorAll('.vault-header-brand-hover').forEach(bindBrandMega);
    root.querySelectorAll('[data-header-menu]').forEach(bindDesktopMenu);
    root.querySelectorAll('[data-mobile-menu]').forEach(bindMobileMenu);
    root.querySelectorAll('[data-localization-select]').forEach(bindLocalization);
    root.querySelectorAll('[data-site-header]').forEach((header) => {
      if (header.classList.contains('site-header--sticky')) header.closest('.shopify-section')?.classList.add('section-header--sticky');
    });
  };

  let lastY = getScrollY();
  const updateScroll = () => {
    const y = getScrollY();
    const delta = y - lastY;
    document.querySelectorAll('[data-site-header]').forEach((header) => header.classList.toggle('is-scrolled', y > 12));
    if (delta > 5 && y > 12) closeAllHeaderMenus();
    document.body.classList.remove('vault-header-stack-hidden');
    lastY = y;
  };

  document.addEventListener('click', (event) => {
    const coverClose = event.target.closest('[data-vault-magazine-close]');
    if (coverClose) {
      event.preventDefault();
      closeOpeningCover(coverClose);
      return;
    }
    if (!event.target.closest('[data-header-menu], .vault-header-brand-hover')) closeAllHeaderMenus();
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAllHeaderMenus();
  });

  desktopMedia.addEventListener('change', () => {
    closeAllHeaderMenus();
    document.body.classList.remove('vault-header-stack-hidden');
    lastY = getScrollY();
  });

  let frame = null;
  const onScroll = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      updateScroll();
      frame = null;
    });
  };

  scrollRoot.addEventListener('scroll', onScroll, { passive: true });
  if (scrollRoot !== window) window.addEventListener('scroll', onScroll, { passive: true });

  const start = () => { initialize(); updateScroll(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
    updateScroll();
  });
})();
